import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import { FRAGMENT_RECOMPOSE_REQUEST } from './schema';

const MUTATION = gql`
  mutation RephraseTexts(
    $projectId: ID!
    $assetType: String!
    $texts: [String!]!
    $mode: String
    $keywords: String
    $debugAcPrompt: String
    $generateMore: Boolean
    $tovId: ID
    $tone: String
    $agePreset: AgePresetEnum
    $numberOfVariations: Int
    $language: String
  ) {
    rephraseTexts(
      projectId: $projectId
      assetType: $assetType
      texts: $texts
      recomposeMode: $mode
      keywords: $keywords
      debugAcPrompt: $debugAcPrompt
      generateMore: $generateMore
      tovId: $tovId
      tone: $tone
      agePreset: $agePreset
      numberOfVariations: $numberOfVariations
      language: $language
    ) {
      ...RecomposeRequest
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
`;

const prepareContext = (projectId, assetType, params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"recompose" request [projectId: ${projectId}, assetType: ${assetType}, params: ${JSON.stringify(
    params
  )}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const rephraseTexts = (projectId, assetType, params) => {
  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables: {
        projectId,
        assetType,
        texts: params.texts,
        mode: params.mode,
        keywords: params.keywords,
        debugAcPrompt: params.debugAcPrompt,
        generateMore: params.generateMore,
        tovId: params.toneOfVoice,
        tone: params.tone,
        agePreset: params.agePreset,
        numberOfVariations: params.numberOfVariations,
        language: params.language,
      },
      context: prepareContext(projectId, assetType, params),
    })
    .then(({ data }) => getSingleProp(data));
};
